import { SliderArrow } from "@components/slider"
import { PreviewPlayer } from "@components/video"
import { FlexBox } from "@components/wrapper"
import { flex_center } from "@constants/styles"
import { SchoolVideoPreview } from "@interfaces/school"
import clsx from "clsx"
import Image from "next/image"
import { useState } from "react"
import { IoChevronBackSharp, IoChevronForwardSharp, IoPlay } from "react-icons/io5"
import Carousel from "react-multi-carousel"
import { ProgramHeading } from "../general/ProgramHeading"

export const ProgramVideoPreview = ({ data }: { data: SchoolVideoPreview[] }) => {
  const [previewIndex, setPreviewIndex] = useState(0)

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 4,
    },
  }

  const youtubeOnly = data.filter((d) => d.video_link.includes("youtube"))

  if (!youtubeOnly.length) {
    return <></>
  }

  const handleClickSlider = (mode: "back" | "forward") => () => {
    switch (mode) {
      case "back":
        setPreviewIndex(previewIndex - 1)
        break
      case "forward":
        setPreviewIndex(previewIndex + 1)
        break

      default:
        break
    }
  }

  return (
    <div className={clsx("relative sm:mb-15", "mb-8")} id="video-preview1">
      <ProgramHeading
        id="video-preview"
        title="cuplikan"
        subTitle="Mau Tau Serunya Belajar di Harisenin.com? Jawabannya Ada di Video Ini!"
      />

      <div
        className={clsx("grid relative w-full", youtubeOnly.length > 1 && "gap-4.5", "sm:hidden")}
      >
        <PreviewPlayer
          url={youtubeOnly[previewIndex].video_link}
          videoTitle="Introduction Video"
          className="w-full h-[50vw] !mt-0"
          thumbnail={youtubeOnly[previewIndex].video_thumbnail}
        />

        {/* {youtubeOnly.length > 1 && (
            <FlexBox className="mx-auto">
              {youtubeOnly.map((_, idx) => (
                <button
                  key={idx}
                  className={clsx(
                    "wh-3 rounded-full mx-1.5 border-0 transition-all duration-200",
                    previewIndex === idx ? "bg-blue" : "bg-grey-c4 w-auto rounded-0"
                  )}
                  onClick={() => setPreviewIndex(idx)}
                />
              ))}
            </FlexBox>
          )} */}

        <>
          {previewIndex > 0 && (
            <button
              className={clsx(
                "absolute rounded-full bg-white shadow-[0px_2px_10px_0px_rgba(58,53,65,0.10)] z-[10]",
                "w-[30px] h-[30px] text-2xl",
                "flex items-center justify-center",
                "top-[45%] -left-[28px]"
              )}
              onClick={handleClickSlider("back")}
            >
              <IoChevronBackSharp />
            </button>
          )}
          {previewIndex < youtubeOnly.length - 1 && (
            <button
              className={clsx(
                "absolute rounded-full bg-white shadow-[0px_2px_10px_0px_rgba(58,53,65,0.10)] z-[10]",
                "w-[30px] h-[30px] text-2xl",
                "flex items-center justify-center",
                "top-[45%] -right-[12px]"
              )}
              onClick={handleClickSlider("forward")}
            >
              <IoChevronForwardSharp />
            </button>
          )}
        </>
      </div>

      <div
        className={clsx(
          "grid relative w-full",
          youtubeOnly.length > 4 && "gap-9",
          "sm-only:hidden"
        )}
      >
        <PreviewPlayer
          url={youtubeOnly[previewIndex].video_link}
          videoTitle="Introduction Video"
          className="w-full h-[40vw] sm-only:mb-[18px]"
          thumbnail={youtubeOnly[previewIndex].video_thumbnail}
        />

        {youtubeOnly.length < 4 && (
          <>
            {previewIndex > 0 && (
              <button
                className={clsx(
                  "absolute rounded-full bg-white shadow-[0px_2px_10px_0px_rgba(58,53,65,0.10)] z-[10]",
                  "w-[44px] h-[44px] text-2xl",
                  "flex items-center justify-center",
                  "top-[45%] -left-[28px]"
                )}
                onClick={handleClickSlider("back")}
              >
                <IoChevronBackSharp />
              </button>
            )}
            {previewIndex < youtubeOnly.length - 1 && (
              <button
                className={clsx(
                  "absolute rounded-full bg-white shadow-[0px_2px_10px_0px_rgba(58,53,65,0.10)] z-[10]",
                  "w-[44px] h-[44px] text-2xl",
                  "flex items-center justify-center",
                  "top-[45%] -right-[28px]"
                )}
                onClick={handleClickSlider("forward")}
              >
                <IoChevronForwardSharp />
              </button>
            )}
          </>
        )}

        {youtubeOnly.length >= 4 && (
          <div className="relative -ml-5">
            <Carousel
              responsive={responsive}
              ssr={true} // means to render carousel on server-side.
              itemClass="sm-only:mb-5 w-full"
              containerClass={clsx("sm:-ml-4 w-[69.6vw]")}
              arrows={false}
              draggable={false}
              customButtonGroup={
                <SliderArrow
                  length={youtubeOnly.length}
                  displayedSlide={4}
                  leftClassName="w-[44px] h-[44px] -left-[20px] top-[24.1%]"
                  rightClassName="w-[44px] h-[44px] -right-[20px] top-[24.1%]"
                />
              }
              renderButtonGroupOutside
            >
              {youtubeOnly.map((value, i) => (
                <div key={i} className={clsx("pl-9 cursor-pointer relative w-full")}>
                  <div
                    className={clsx("relative ", previewIndex === i && "border border-green")}
                    onClick={() => setPreviewIndex(i)}
                  >
                    <FlexBox className="absolute top-0 wh-full" align="center" justify="center">
                      <FlexBox
                        align="center"
                        justify="center"
                        className="rounded-full w-[42px] h-[42px]"
                        style={{
                          background: "rgba(217, 217, 217, 0.9)",
                          backgroundBlendMode: "soft-light",
                          backdropFilter: "blur(3.55036px)",
                        }}
                      >
                        <div
                          className={clsx("rounded-full bg-white w-[31px] h-[31px]", flex_center)}
                        >
                          <IoPlay className="sm:text-xl" />
                        </div>
                      </FlexBox>
                    </FlexBox>
                    <Image
                      src={value.video_thumbnail}
                      width={400}
                      height={212}
                      alt={value.video_title}
                      className="w-full sm:h-[8.2vw]"
                    />
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        )}
      </div>
    </div>
  )
}

